import React, { useEffect, useState } from "react";
import { sendToAndroid } from "../services/androidBridge";
import {
  Check,
  ChevronRight,
  Phone,
  ReceiptText,
  Search,
  UserRound,
  WalletCards,
} from "lucide-react";
import "./School.css";
import { encryptData } from "../utils/helpFunction";
import {
  schoolLanguageOptions,
  transferListLanguageOptions,
} from "./dropdown/dropdown-data";

const School = () => {
  const [selectedAccount, setSelectedAccount] = useState("");
  const [accountList, setAccountList] = useState([]);

  const [confirmMessage, setConfirmMessage] = useState("notLoaded");
  const [successMessage, setSuccessMessage] = useState("notLoaded");
  const [jwt, setJwt] = useState();
  const [userName, setUserName] = useState("");

  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [closeLoading, setCloseLoading] = useState(false);
  const [title, setTitle] = useState();
  const [warning, setWarning] = useState("");
  const [onConfirm, setOnConfirm] = useState("");
  const [transferRequest, setTransferRequest] = useState("");
  const [, setExtractedUrl] = useState("");
  const [selectedPeriods, setSelectedPeriods] = useState([]);
  const [calculatedPayment, setCalculatedPayment] = useState(null);
  const [checked, setChecked] = useState(false);
  const [buttonText, setButtonText] = useState("Search");
  const [, setPeriodIds] = useState([]);

  const [searchBy, setSearchBy] = useState("pnr");
  const [pnr, setPnr] = useState("");
  const [studentId, setStudentId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [parentStudents, setParentStudents] = useState([]);
  const [selectedParentStudent, setSelectedParentStudent] = useState(null);
  const [result, setResult] = useState(null);
  const [error] = useState(null);

  const [schoolList, setSchoolList] = useState([]);
  const [tenant, setTenant] = useState("");
  const [selectedFee, setSelectedFee] = useState("");
  const [feeDetail, setFeeDetail] = useState(null);
  const [checkedItems, setCheckedItems] = useState([]);

  const [isFirst, setIsFirst] = useState(true);

  const isFormValid = () => {
    if (!selectedAccount || selectedAccount === "choose") return false;
    if (!tenant || tenant === "school") return false;
    if (searchBy === "pnr" && !pnr) return false;
    if (searchBy === "phone" && !/^0[79]\d{8}$/.test(phoneNumber))
      return false;
    if (
      searchBy === "student" &&
      (!studentId ||
        studentId.length < 6 ||
        !tenant ||
        !studentId.match("^[a-zA-Z]{4,5}\\-\\d+$"))
    )
      return false;
    return true;
  };

  const handleSearch = () => {
    if (searchBy === "pnr") {
      sendDataToAndroid("searchPnr");
    } else if (searchBy === "phone") {
      setParentStudents([]);
      setSelectedParentStudent(null);
      setResult(null);
      sendDataToAndroid("searchParentStudents");
    } else {
      sendDataToAndroid("searchStudent");
    }
  };

  const handleParentStudentSelect = (student) => {
    setSelectedParentStudent(student);
    setStudentId(student.rollNumber);
    setResult(null);
    setFeeDetail(null);
    setSelectedFee(null);
    setSelectedPeriods([]);
    setCalculatedPayment(null);
    sendDataToAndroid("searchStudent", { studentId: student.rollNumber });
  };

  const paymentDetail = () => {
    if (calculatedPayment) {
      const message =
        `<b>SchoolFee payment for student : </b> ${feeDetail.fullName} <br><br>` +
        `<b>Amount: </b> ${calculatedPayment.finalAmount} <br><br>` +
        `<b>Reason: Payment for </b> ${selectedPeriods.map(
          (period) => period.name
        )} <br><br>`;

      setTransferRequest({
        studentId: feeDetail.studentId,
        periods: selectedPeriods.map((period) => period.id),
        feeId: feeDetail.fee.feeId,
        feeMode: feeDetail.feeMode.toUpperCase(),
        fees: [
          {
            feeId: feeDetail.fee.feeId,
            variableAmount: feeDetail.fee.amount,
          },
        ],
        pnr: calculatedPayment.pnr,
        paymentMode: "CASH",
        collectionType: "BANK",
        createdBy: userName,
        branchCode: 1,
        branchName: "omni plus",
        accountHolder: userName,
        accountNumber: selectedAccount,
        paymentDate: new Date(),
        variableAmount: calculatedPayment.totalAmount,
        totalAmount: calculatedPayment.finalAmount,

        tenant: tenant,
        hashedValue: "hashedValue",
      });
      setConfirmMessage(message);
    } else if (selectedPeriods.length > 0 || (checked && feeDetail)) {
      sendDataToAndroid("calculatePayment");
    } else {
      sendDataToAndroid("searchFee");
    }
  };

  const payPnr = () => {
    const message =
      `<b>SchoolFee payment for student : </b> ${feeDetail.studentName} <br><br>` +
      `<b>Amount: </b> ${feeDetail.amount} <br><br>` +
      `<b>PNR</b> ${feeDetail.pnr} <br><br>`;

    setTransferRequest({
      pnr: pnr,
      createdBy: "omni app",
      branchCode: "1",
      branchName: "Omni plus",
      accountHolder: userName,
      accountNumber: selectedAccount,
      paymentDate: TodayDate(),
      transactionId: "string",
      tenant: tenant,
      hashedValue: "hashedValue",
    });
    setConfirmMessage(message);
  };

  const handleFirstRender = (request) => {
    if (!isFirst) {
      sendDataToAndroid(request);
    }
    setIsFirst(false);
  };

  useEffect(() => {
    sendDataToAndroid("first");

    window.receiveDataFromAndroid = (data) => {
      var dataString = JSON.stringify(data);
      var obj = JSON.parse(dataString);

      if (JSON.parse(obj.request).name === "accountList") {
        if (
          obj.response !== undefined &&
          JSON.parse(obj.response).data !== undefined
        ) {
          let uniqueAccountList = [];
          JSON.parse(JSON.parse(obj.response).data).forEach((account) => {
            uniqueAccountList = [
              ...uniqueAccountList,
              { label: account.accounts, value: account.accounts },
            ];
            setAccountList([...uniqueAccountList]);
          });
        }
      }

      if (JSON.parse(obj.request).name === "confirmResponse") {
        setOnConfirm("true");
      }

      if (JSON.parse(obj.request).name === "jwt") {
        setJwt(JSON.parse(obj.response).data);
      }

      if (JSON.parse(obj.request).name === "response") {
        const urlFromResponse = JSON.parse(obj.request).url;
        setExtractedUrl(urlFromResponse);

        handleDataBasedOnUrl(urlFromResponse, JSON.parse(obj.response).data);
      }

      if (JSON.parse(obj.request).name === "userName") {
        setUserName(JSON.parse(obj.response).data);
      }
    };
  }, []);

  const handleDataBasedOnUrl = (url, responseData) => {
    console.log("method called " + url);
    if (url.includes("InternalFundTransfer/rest/internalFundTransfer")) {
      const parsedResponse = JSON.parse(responseData);

      if (parsedResponse.status) {
        setSuccessMessage(parsedResponse.statusDesc);
        setErrorMessage("");
      } else {
        setErrorMessage(parsedResponse.statusDesc);
        setSuccessMessage("");
      }
    } else if (url.includes("schools")) {
      const { data, status } = JSON.parse(responseData);
      console.log(JSON.stringify(data));
      if (status === true) {
        setSchoolList(data.items);
      }
    } else if (url.includes("studentsByParentPhone")) {
      const { data, status, desc } = JSON.parse(responseData);
      if (status === true) {
        const students = Array.isArray(data?.items)
          ? data.items
          : Array.isArray(data?.payload?.items)
          ? data.payload.items
          : Array.isArray(data?.payload)
          ? data.payload
          : Array.isArray(data)
          ? data
          : [];

        setParentStudents(students);
        setSelectedParentStudent(null);
        setStudentId("");
        setResult(null);
        setFeeDetail(null);
        setSelectedFee(null);

        if (students.length === 0) {
          setErrorMessage(desc || "No students found for this phone number.");
        }
      } else {
        setParentStudents([]);
        setErrorMessage(desc || "Unable to find students for this phone number.");
        setSuccessMessage("");
      }
    } else if (url.includes("paymentList")) {
      const { data, status, desc } = JSON.parse(responseData);
      console.log(JSON.stringify(data));
      if (status === true) {
        setResult(data.payload);
      } else {
        setErrorMessage(desc);
        setSuccessMessage("");
      }
    } else if (url.includes("feeSearch")) {
      const { data, status, desc } = JSON.parse(responseData);
      console.log(JSON.stringify(data));
      if (status === true) {
        setFeeDetail(data.payload);
      } else {
        setErrorMessage(desc);
        setSuccessMessage("");
      }
    } else if (url.includes("calculate")) {
      const { data, status, desc } = JSON.parse(responseData);
      console.log(JSON.stringify(data));
      if (status === true) {
        setCalculatedPayment(data.payload);
      } else {
        setErrorMessage(desc);
        setSuccessMessage("");
      }
    } else if (url.includes("feePayment")) {
      const { data, status, desc } = JSON.parse(responseData);
      console.log("fee Payment log  " + JSON.stringify(data));
      if (status === true) {
        setSuccessMessage(
          `School fee payment of ${data.payload.amount} for ${data.payload.studentName} student id ${data.payload.rollNumber} of ${data.payload.reason} has been paid to ${data.payload.schoolName} with pnr ${data.payload.pnr} and reference number ${data.payload.transactionId}.`
        );
      } else {
        setErrorMessage(desc);
        setSuccessMessage("");
      }
    } else if (url.includes("payPnr")) {
      const { data, status, desc } = JSON.parse(responseData);
      console.log(JSON.stringify(data));
      if (status === true) {
        console.log("feeData", feeDetail);
        setSuccessMessage(
          `School fee payment of ${data.payload.totalAmount} with pnr ${data.payload.pnr} and reference number ${data.payload.cbsRef} has been completed.`
        );
      } else {
        setErrorMessage(desc);
        setSuccessMessage("");
      }
    } else if (url.includes("pnr")) {
      const { data, status, desc } = JSON.parse(responseData);
      console.log(JSON.stringify(data));
      if (status === true) {
        setFeeDetail(data.payload);
      } else {
        setErrorMessage(desc);
        setSuccessMessage("");
      }
    }
  };

  const handleCheckboxChange = (index) => {
    const updatedCheckedItems = [...checkedItems];

    if (checkedItems[index]) {
      for (let i = index; i < updatedCheckedItems.length; i++) {
        updatedCheckedItems[i] = false;
      }
    } else {
      if (index > 0 && !checkedItems[index - 1]) {
        setWarning("You must check the preceding checkbox first!");
        return;
      }
      updatedCheckedItems[index] = true;
    }

    setCheckedItems(updatedCheckedItems);

    const newSelectedPeriods = feeDetail.fee.periods.filter(
      (period, i) => updatedCheckedItems[i]
    );
    setSelectedPeriods(newSelectedPeriods);
  };

  const handleChange = (e) => {
    const selectedPeriod = feeDetail?.fee.feeId;
    const isChecked = e.target.checked;
    setChecked(isChecked);
    setSelectedPeriods(isChecked ? [selectedPeriod] : []);
  };

  function capitalizeFirstLetter(string) {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const handleAccountChange = (e) => {
    setSelectedAccount(e.target.value);
    setResult(null);
    setFeeDetail(null);
    setSelectedFee(null);
    setParentStudents([]);
    setSelectedParentStudent(null);
  };

  const handleTenantChange = (e) => {
    setTenant(e.target.value);
    setResult(null);
    setFeeDetail(null);
    setSelectedFee(null);
    setStudentId("");
    setParentStudents([]);
    setSelectedParentStudent(null);
  };

  const handleStudentIdChange = (e) => {
    setStudentId(e.target.value.trim().toUpperCase());
    setResult(null);
    setFeeDetail(null);
    setSelectedFee(null);
  };

  const handlePnrChange = (e) => {
    setPnr(e.target.value.trim().toUpperCase());
    setResult(null);
    setFeeDetail(null);
    setSelectedFee(null);
  };

  const handlePhoneNumberChange = (e) => {
    const nextPhoneNumber = e.target.value.replace(/\D/g, "").slice(0, 10);
    setPhoneNumber(nextPhoneNumber);
    setParentStudents([]);
    setSelectedParentStudent(null);
    setStudentId("");
    setResult(null);
    setFeeDetail(null);
    setSelectedFee(null);
  };

  useEffect(() => {
    if (searchBy === "pnr" && pnr) {
      setResult(null);
      setFeeDetail(null);
      setSelectedFee(null);
    } else if (searchBy === "student" && (studentId || tenant)) {
      setResult(null);
      setFeeDetail(null);
      setSelectedFee(null);
    } else if (searchBy === "phone" && (phoneNumber || tenant)) {
      setResult(null);
      setFeeDetail(null);
      setSelectedFee(null);
    }
  }, [pnr, studentId, phoneNumber, tenant, searchBy]);

  useEffect(() => {
    if (selectedFee) {
      setFeeDetail(null);
      setSelectedPeriods([]);
      setCalculatedPayment(null);
      setCheckedItems([]);
      setChecked(false);
    }
  }, [selectedFee]);

  useEffect(() => {
    if (selectedPeriods) {
      setCalculatedPayment(null);
    }
  }, [selectedPeriods]);

  useEffect(() => {
    if (calculatedPayment) {
      setButtonText(schoolLanguageOptions[jwt]?.labels[14]);
    } else if (selectedFee) {
      if (selectedFee.feeClass === "periodic") {
        setButtonText(
          selectedPeriods.length > 0
            ? schoolLanguageOptions[jwt]?.labels[24]
            : schoolLanguageOptions[jwt]?.labels[25]
        );
      } else {
        setButtonText(
          checked
            ? schoolLanguageOptions[jwt]?.labels[24]
            : schoolLanguageOptions[jwt]?.labels[25]
        );
      }
    } else {
      setButtonText("Continue");
    }
  }, [selectedPeriods, checked, selectedFee, calculatedPayment]);

  useEffect(() => {
    if (!isFirst) {
      setTitle(transferListLanguageOptions[jwt][3]);
    }
    setIsFirst(false);
  }, [jwt]);
  useEffect(() => {
    handleFirstRender("title");
  }, [title]);

  useEffect(() => {
    handleFirstRender("confirm");
  }, [confirmMessage]);
  useEffect(() => {
    handleFirstRender("success");
  }, [successMessage]);

  useEffect(() => {
    handleFirstRender("warning");
  }, [errorMessage]);

  useEffect(() => {
    handleFirstRender("openLoading");
  }, [loading]);

  useEffect(() => {
    handleFirstRender("openLoading");
    if (closeLoading) {
      setLoading(false);
      setCloseLoading(false);
    }
  }, [closeLoading]);

  useEffect(() => {
    handleFirstRender("warning");
  }, [warning]);

  useEffect(() => {
    if (onConfirm !== "") {
      handleFirstRender("request");
    }
  }, [onConfirm]);

  useEffect(() => {
    sendDataToAndroid("school");
  }, []);

  function TodayDate() {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${yyyy}-${mm}-${dd}`;

    return formattedDate;
  }

  const sendDataToAndroid = (name, requestData = {}) => {
    var transferData = {
      transferData: [],
    };
    if (name === "return") {
      transferData = {
        transferData: [
          {
            type: "return",
            request: { name: "graphData" },
            response: {},
            name: "",
          },
        ],
      };
    } else if (name === "title") {
      transferData = {
        transferData: [
          {
            type: "title",
            request: { name: "title" },
            response: { data: title },
            name: "",
          },
        ],
      };
    } else if (name === "first") {
      transferData = {
        transferData: [
          {
            type: "first",
            request: { name: "first" },
            response: {},
            name: "",
          },
        ],
      };
    } else if (name === "confirm") {
      transferData = {
        transferData: [
          {
            type: "confirm",
            request: { name: "confirm" },
            response: { data: confirmMessage },
            name: "",
          },
        ],
      };
    } else if (name === "openLoading") {
      transferData = {
        transferData: [
          {
            type: "openLoading",
            request: { name: "openLoading" },
            response: { data: loading },
            name: "",
          },
        ],
      };
    } else if (name === "closeLoading") {
      transferData = {
        transferData: [
          {
            type: "closeLoading",
            request: { name: "closeLoading" },
            response: { data: closeLoading },
            name: "",
          },
        ],
      };
    } else if (name === "warning") {
      transferData = {
        transferData: [
          {
            type: "warning",
            request: { name: "warning" },
            response: { data: errorMessage },
            name: "",
          },
        ],
      };
    } else if (name === "error") {
      transferData = {
        transferData: [
          {
            type: "error",
            request: { name: "error" },
            response: { data: errorMessage },
            name: "",
          },
        ],
      };
    } else if (name === "success") {
      transferData = {
        transferData: [
          {
            type: "success",
            request: { name: "success" },
            response: { data: successMessage },
            name: "",
          },
        ],
      };
    } else if (name === "school") {
      console.log("Data sent to fetch school");
      transferData = {
        transferData: [
          {
            type: "requestPostNoLoading",
            request: { name: "schoolApp/services/schools" },
            response: { data: { tenant: "SCUL" } },
            name: "",
          },
        ],
      };
    } else if (name === "searchStudent") {
      console.log("Data sent to fetch school");
      transferData = {
        transferData: [
          {
            type: "requestPost",
            request: { name: "schoolApp/services/paymentList" },
            response: {
              data: {
                studentId: requestData.studentId || studentId,
                tenant: tenant,
                hashedValue: "hashedValue",
              },
            },
            name: "",
          },
        ],
      };
    } else if (name === "searchParentStudents") {
      transferData = {
        transferData: [
          {
            type: "requestPost",
            request: {
              name: "schoolApp/services/studentsByParentPhone",
            },
            response: {
              data: {
                phoneNumber: phoneNumber,
                tenant: tenant,
                hashedValue: "hashedValue",
              },
            },
            name: "",
          },
        ],
      };
    } else if (name === "searchPnr") {
      console.log("Data sent to fetch pnr");
      transferData = {
        transferData: [
          {
            type: "requestPost",
            request: { name: "schoolApp/services/pnr" },
            response: {
              data: {
                pnr: pnr,
                tenant: tenant,
                hashedValue: "hashedValue",
              },
            },
            name: "",
          },
        ],
      };
    } else if (name === "searchFee") {
      console.log("Data sent to fetch fee detail");
      console.log(JSON.stringify(selectedFee));
      transferData = {
        transferData: [
          {
            type: "requestPost",
            request: { name: "schoolApp/services/feeSearch" },
            response: {
              data: {
                studentId: studentId,
                feeId: selectedFee?.feeId,
                periodic: selectedFee.feeClass === "periodic",
                tenant: tenant,
                hashedValue: "hashedValue",
              },
            },
            name: "",
          },
        ],
      };
    } else if (name === "calculatePayment") {
      console.log("Data sent to calculate payment");
      let calculatedPeriodIds = [];

      if (selectedFee.feeClass === "periodic") {
        calculatedPeriodIds = selectedPeriods.map((period) => period.id);
      } else {
        calculatedPeriodIds = [0];
      }

      setPeriodIds(calculatedPeriodIds);

      transferData = {
        transferData: [
          {
            type: "requestPost",
            request: { name: "schoolApp/services/calculate" },
            response: {
              data: {
                encryptedString: encryptData(
                  JSON.stringify({
                    studentId: feeDetail.studentId,
                    periods: calculatedPeriodIds,
                    feeId: feeDetail.fee.feeId,
                    feeMode:
                      selectedFee.feeClass === "periodic"
                        ? feeDetail.fee.feeMode.toUpperCase()
                        : feeDetail.feeMode.toUpperCase(),
                    scholarship: feeDetail.scholarship,
                    tenant: tenant,
                    hashedValue: "hashedValue",
                  })
                ),
              },
            },
            name: "",
          },
        ],
      };
    } else if (name === "request") {
      transferData = {
        transferData: [
          {
            type: "requestPost",
            request: {
              name:
                searchBy === "pnr"
                  ? "schoolApp/services/payPnr"
                  : "schoolApp/services/feePayment",
            },
            response: {
              data: {
                encryptedString: encryptData(JSON.stringify(transferRequest)),
              },
            },
            name: "",
          },
        ],
      };
    }
    sendToAndroid(transferData);
    setConfirmMessage("");
    setOnConfirm("");
    setErrorMessage("");
  };

  const searchComplete =
    (searchBy === "pnr" && Boolean(feeDetail)) ||
    (searchBy !== "pnr" && Boolean(result));
  const feeSelectionComplete = Boolean(calculatedPayment);
  const paymentActionDisabled =
    !selectedFee ||
    (Boolean(feeDetail) &&
      !calculatedPayment &&
      ((selectedFee?.feeClass === "periodic" &&
        selectedPeriods.length === 0) ||
        (selectedFee?.feeClass !== "periodic" && !checked)));

  const formatAmount = (value) => {
    const numericValue = Number(value);
    return `${Number.isFinite(numericValue)
      ? numericValue.toLocaleString()
      : value || 0} Birr`;
  };

  return (
    <main className="service-screen school-payment">
      <div className="w-full">

        <div className="border-b border-slate-100 px-5 py-4 sm:px-6">
          <ol className="grid grid-cols-3 gap-2" aria-label="Payment progress">
            {[
              { label: "Find student", done: searchComplete, active: true },
              {
                label:
                  searchBy === "pnr" ? "Review payment" : "Select fees",
                done: feeSelectionComplete,
                active: searchComplete,
              },
              {
                label: "Confirm",
                done: false,
                active: feeSelectionComplete,
              },
            ].map((step, index) => (
              <li key={step.label} className="min-w-0">
                <div className="flex items-center">
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                      step.done
                        ? "bg-emerald-500 text-white"
                        : step.active
                        ? "bg-[#0351b3] text-white"
                        : "bg-slate-200 text-slate-500"
                    }`}
                  >
                    {step.done ? <Check size={14} /> : index + 1}
                  </span>
                  {index < 2 && (
                    <span
                      className={`mx-1 h-0.5 flex-1 ${
                        step.done ? "bg-emerald-400" : "bg-slate-200"
                      }`}
                    />
                  )}
                </div>
              </li>
            ))}
          </ol>
        </div>

        <div className="space-y-6 p-5 sm:p-6">
          <section aria-labelledby="payment-source-heading">
            <div className="mb-3 flex items-center gap-2">
              <WalletCards
                size={18}
                className="text-[#0351b3]"
                aria-hidden="true"
              />
              <h2
                id="payment-source-heading"
                className="font-semibold text-slate-800"
              >
                Payment source
              </h2>
            </div>

            <div className="grid gap-4 sm:grid-cols-2">
              <div>
                <label className="mb-1.5 block text-sm font-medium text-slate-700">
                  {schoolLanguageOptions[jwt]?.labels[0]}
                </label>
                <select
                  value={selectedAccount}
                  onChange={handleAccountChange}
                  className="school-control"
                >
                  <option key={0} value={"choose"}>
                    {schoolLanguageOptions[jwt]?.labels[0]}
                  </option>
                  {accountList.map((s) => (
                    <option key={s.id || s.value} value={s.value}>
                      {s.value}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="mb-1.5 block text-sm font-medium text-slate-700">
                  {schoolLanguageOptions[jwt]?.labels[1]}
                </label>
                <select
                  value={tenant}
                  onChange={handleTenantChange}
                  className="school-control"
                >
                  <option key={0} value={"school"}>
                    {schoolLanguageOptions[jwt]?.labels[1]}
                  </option>
                  {schoolList.map((s) => (
                    <option key={s.id || s.schoolCode} value={s.schoolCode}>
                      {s.schoolName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </section>

          <section
            className="border-t border-slate-100 pt-5"
            aria-labelledby="student-search-heading"
          >
            <div className="mb-3 flex items-center gap-2">
              <Search
                size={18}
                className="text-[#0351b3]"
                aria-hidden="true"
              />
              <h2
                id="student-search-heading"
                className="font-semibold text-slate-800"
              >
                {schoolLanguageOptions[jwt]?.labels[2]}
              </h2>
            </div>

            <div className="mb-4 grid grid-cols-3 gap-2">
              <label
                className={`school-search-option ${
                  searchBy === "pnr" ? "school-search-option-active" : ""
                }`}
              >
                <input
                  className="sr-only"
                  type="radio"
                  name="searchBy"
                  value="pnr"
                  checked={searchBy === "pnr"}
                  onChange={() => {
                    setSearchBy("pnr");
                    setResult(null);
                    setSelectedFee(null);
                  }}
                />
                <ReceiptText size={18} aria-hidden="true" />
                <span>
                  {schoolLanguageOptions[jwt]?.labels[3] || "By PNR"}
                </span>
              </label>
              <label
                className={`school-search-option ${
                  searchBy === "student" ? "school-search-option-active" : ""
                }`}
              >
                <input
                  className="sr-only"
                  type="radio"
                  name="searchBy"
                  value="student"
                  checked={searchBy === "student"}
                  onChange={() => {
                    setSearchBy("student");
                    setResult(null);
                    setFeeDetail(null);
                    setSelectedFee(null);
                  }}
                />
                <UserRound size={18} aria-hidden="true" />
                <span>
                  {schoolLanguageOptions[jwt]?.labels[4] || "By Student ID"}
                </span>
              </label>
              <label
                className={`school-search-option ${
                  searchBy === "phone" ? "school-search-option-active" : ""
                }`}
              >
                <input
                  className="sr-only"
                  type="radio"
                  name="searchBy"
                  value="phone"
                  checked={searchBy === "phone"}
                  onChange={() => {
                    setSearchBy("phone");
                    setResult(null);
                    setFeeDetail(null);
                    setSelectedFee(null);
                    setStudentId("");
                    setParentStudents([]);
                    setSelectedParentStudent(null);
                  }}
                />
                <Phone size={18} aria-hidden="true" />
                <span>
                  {schoolLanguageOptions[jwt]?.labels[26] || "By Phone Number"}
                </span>
              </label>
            </div>

            {searchBy === "pnr" ? (
              <div>
                <label className="mb-1.5 block text-sm font-medium text-slate-700">
                  {schoolLanguageOptions[jwt]?.labels[5]}
                </label>
                <input
                  type="text"
                  value={pnr}
                  onChange={handlePnrChange}
                  className="school-control"
                  placeholder="Enter PNR number"
                />
              </div>
            ) : searchBy === "student" ? (
              <div>
                <label className="mb-1.5 block text-sm font-medium text-slate-700">
                  {schoolLanguageOptions[jwt]?.labels[6]}
                </label>
                <input
                  type="text"
                  value={studentId}
                  onChange={handleStudentIdChange}
                  className="school-control"
                  placeholder="For example, ABCD-1234"
                />
              </div>
            ) : (
              <div>
                <label className="mb-1.5 block text-sm font-medium text-slate-700">
                  {schoolLanguageOptions[jwt]?.labels[27] || "Phone Number"}
                </label>
                <div className="relative">
                  <input
                    type="tel"
                    inputMode="numeric"
                    autoComplete="tel"
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    className={`school-control pl-10 ${
                      phoneNumber && !/^0[79]\d{8}$/.test(phoneNumber)
                        ? "school-control-error"
                        : ""
                    }`}
                    placeholder="07XXXXXXXX or 09XXXXXXXX"
                    maxLength={10}
                  />
                </div>
                {phoneNumber && !/^0[79]\d{8}$/.test(phoneNumber) && (
                  <p className="mt-1.5 text-xs text-red-600">
                    Use 10 digits beginning with 07 or 09.
                  </p>
                )}
              </div>
            )}

            <button
              onClick={handleSearch}
              disabled={!isFormValid()}
              className="school-primary-button mt-4"
            >
              <Search size={18} aria-hidden="true" />
              <span>{schoolLanguageOptions[jwt]?.labels[7]}</span>
              <ChevronRight size={18} aria-hidden="true" />
            </button>
          </section>

          {loading && (
            <div className="flex items-center justify-center gap-2 rounded-xl bg-[#eef5fd] p-3 text-sm font-medium text-[#0351b3]">
              <span className="h-4 w-4 animate-spin rounded-full border-2 border-[#c7dcf5] border-t-[#0351b3]" />
              {schoolLanguageOptions[jwt]?.labels[8]}
            </div>
          )}
          {error && (
            <p className="rounded-xl bg-red-50 p-3 text-sm text-red-700">
              {error}
            </p>
          )}

        <div className="space-y-5">
          {searchBy === "phone" && parentStudents.length > 0 && (
            <section className="rounded-2xl border border-slate-200 bg-slate-50 p-4">
              <div className="mb-3 flex items-center justify-between gap-3">
                <h2 className="font-semibold text-slate-800">
                {schoolLanguageOptions[jwt]?.labels[28] || "Select Student"}
                </h2>
                <span className="rounded-full bg-[#e4effb] px-2.5 py-1 text-xs font-semibold text-[#0351b3]">
                  {parentStudents.length}{" "}
                  {parentStudents.length === 1 ? "student" : "students"}
                </span>
              </div>
              <div className="space-y-2">
                {parentStudents.map((student) => (
                  <label
                    key={student.id || student.rollNumber}
                    className={`flex cursor-pointer items-start gap-3 rounded-xl border bg-white p-3.5 transition ${
                      selectedParentStudent?.rollNumber === student.rollNumber
                        ? "border-[#0351b3] ring-2 ring-[#dbe9f9]"
                        : "border-slate-200 hover:border-[#7eacdf]"
                    }`}
                  >
                    <input
                      type="radio"
                      name="parentStudent"
                      checked={
                        selectedParentStudent?.rollNumber === student.rollNumber
                      }
                      onChange={() => handleParentStudentSelect(student)}
                      className="mt-1 h-4 w-4 accent-[#0351b3]"
                    />
                    <span className="min-w-0 flex-1">
                      <strong className="block text-sm text-slate-900">
                        {student.fullName}
                      </strong>
                      <span className="mt-1 block text-xs text-slate-500">
                        {schoolLanguageOptions[jwt]?.labels[29] ||
                          "Roll Number"}
                        : {student.rollNumber}
                      </span>
                      <span className="mt-0.5 block text-xs text-slate-500">
                        {schoolLanguageOptions[jwt]?.labels[15] || "Grade"}:{" "}
                        {student.grade}
                        {student.section
                          ? ` · ${
                              schoolLanguageOptions[jwt]?.labels[30] ||
                              "Section"
                            }: ${student.section}`
                          : ""}
                      </span>
                      {student.gender && (
                        <span className="mt-0.5 block text-xs text-slate-500">
                          {schoolLanguageOptions[jwt]?.labels[31] || "Gender"}:{" "}
                          {student.gender}
                        </span>
                      )}
                    </span>
                  </label>
                ))}
              </div>
            </section>
          )}

          {searchBy === "pnr" && feeDetail && (
            <section className="rounded-2xl border border-emerald-200 bg-emerald-50/50 p-4">
              <div className="mb-4 flex items-start gap-3">
                <span className="rounded-full bg-emerald-100 p-2 text-emerald-700">
                  <ReceiptText size={19} aria-hidden="true" />
                </span>
                <div>
                  <p className="text-xs font-semibold uppercase tracking-wide text-emerald-700">
                    Payment found
                  </p>
                  <h2 className="font-semibold text-slate-900">
                    {feeDetail.studentName}
                  </h2>
                  <p className="text-sm text-slate-500">
                    {feeDetail.schoolName}
                  </p>
                </div>
              </div>
              <dl className="grid grid-cols-2 gap-3 rounded-xl bg-white p-3">
                <div>
                  <dt className="text-xs text-slate-500">
                    {schoolLanguageOptions[jwt]?.labels[11]}
                  </dt>
                  <dd className="mt-0.5 text-sm font-medium text-slate-800">
                    {feeDetail.reason}
                  </dd>
                </div>
                <div className="text-right">
                  <dt className="text-xs text-slate-500">
                    {schoolLanguageOptions[jwt]?.labels[12]}
                  </dt>
                  <dd className="mt-0.5 font-bold text-slate-900">
                    {formatAmount(feeDetail.amount)}
                  </dd>
                </div>
              </dl>
              <button
                onClick={payPnr}
                className="school-primary-button mt-4"
              >
                {loading ? (
                  <>
                    <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white" />
                    {schoolLanguageOptions[jwt]?.labels[13]}
                  </>
                ) : (
                  <>
                    <span>{schoolLanguageOptions[jwt]?.labels[14]}</span>
                    <ChevronRight size={18} aria-hidden="true" />
                  </>
                )}
              </button>
            </section>
          )}

          {searchBy !== "pnr" && result && (
            <section className="border-t border-slate-100 pt-5">
              <div className="mb-4 flex items-center gap-3 rounded-xl bg-[#eef5fd] p-3.5">
                <span className="rounded-full bg-[#dbe9f9] p-2 text-[#0351b3]">
                  <UserRound size={19} aria-hidden="true" />
                </span>
                <div>
                  <p className="font-semibold text-slate-900">
                    {result.fullName}
                  </p>
                  <p className="text-sm text-slate-600">
                    {schoolLanguageOptions[jwt]?.labels[15]}: {result.studClass}
                  </p>
                </div>
              </div>

              <h2 className="mb-2.5 font-semibold text-slate-800">
                Select a fee
              </h2>
              <div className="space-y-2">
                {result.fees?.map((fee) => (
                  <label
                    className={`flex cursor-pointer items-center gap-3 rounded-xl border p-3.5 transition ${
                      selectedFee?.feeId === fee.feeId
                        ? "border-[#0351b3] bg-[#eef5fd] ring-2 ring-[#dbe9f9]"
                        : "border-slate-200 bg-white hover:border-[#7eacdf]"
                    }`}
                    key={fee.feeId || fee.name}
                  >
                    <input
                      type="radio"
                      name="fee"
                      checked={selectedFee && selectedFee.feeId === fee.feeId}
                      onChange={() => {
                        setSelectedFee(fee);
                        setChecked(false);
                        setCheckedItems([]);
                      }}
                      className="h-4 w-4 accent-[#0351b3]"
                    />
                    <span className="min-w-0 flex-1 text-sm font-medium text-slate-800">
                      {fee.name}
                    </span>
                    <strong className="whitespace-nowrap text-sm text-slate-900">
                      {formatAmount(fee.amount)}
                    </strong>
                  </label>
                ))}
              </div>

              {selectedFee && feeDetail && (
                <div className="mt-5">
                  <h2 className="mb-2.5 font-semibold text-slate-800">
                    {schoolLanguageOptions[jwt]?.labels[16]}
                  </h2>
                  <div className="space-y-2 rounded-2xl border border-slate-200 bg-slate-50 p-3">
                    {feeDetail.feeMode === "periodic" ? (
                      feeDetail.fee.periods?.map((period, index) => (
                        <label
                          key={period.id}
                          className={`flex items-center gap-3 rounded-xl border p-3 text-sm transition ${
                            checkedItems[index]
                              ? "border-emerald-400 bg-emerald-50 text-slate-800"
                              : index > 0 && !checkedItems[index - 1]
                              ? "border-slate-200 bg-slate-100 text-slate-400"
                              : "border-slate-200 bg-white text-slate-700"
                          }`}
                        >
                          <input
                            type="checkbox"
                            name="period"
                            checked={checkedItems[index]}
                            onChange={() => handleCheckboxChange(index)}
                            disabled={index > 0 && !checkedItems[index - 1]}
                            className={`h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 ${
                              index > 0 && !checkedItems[index - 1]
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                          />
                          <span className="font-medium">
                            {capitalizeFirstLetter(period.name.toLowerCase())}
                          </span>
                        </label>
                      ))
                    ) : (
                      <label
                        key={feeDetail.fee?.feeId}
                        className={`flex items-center gap-3 rounded-xl border p-3.5 ${
                          checked
                            ? "border-emerald-400 bg-emerald-50"
                            : "border-slate-200 bg-white"
                        }`}
                      >
                        <input
                          type="checkbox"
                          name="period"
                          checked={checked || false}
                          onChange={handleChange}
                          className="h-4 w-4 accent-emerald-600"
                        />
                        <span className="min-w-0 flex-1 text-sm font-medium text-slate-800">
                          {feeDetail.fee?.feeTitle || "Fee"}
                        </span>
                        <strong className="whitespace-nowrap text-sm text-slate-900">
                          {formatAmount(
                            (feeDetail.fee?.unitAmount || 0) +
                              (feeDetail.fee?.penalty || 0)
                          )}
                        </strong>
                      </label>
                    )}
                  </div>
                </div>
              )}

              {calculatedPayment && (
                <div className="mt-5">
                  <div className="mb-2.5 flex items-center gap-2">
                    <ReceiptText
                      size={18}
                      className="text-[#0351b3]"
                      aria-hidden="true"
                    />
                    <h2 className="font-semibold text-slate-800">
                    {schoolLanguageOptions[jwt]?.labels[18]}
                    </h2>
                  </div>

                  <div className="overflow-hidden rounded-2xl border border-slate-200">
                    <dl className="divide-y divide-slate-100 bg-white">
                      {[
                        [
                          schoolLanguageOptions[jwt]?.labels[19],
                          calculatedPayment.totalAmount,
                        ],
                        [
                          schoolLanguageOptions[jwt]?.labels[20],
                          calculatedPayment.totalDiscount,
                        ],
                        [
                          schoolLanguageOptions[jwt]?.labels[21],
                          calculatedPayment.totalPenalty,
                        ],
                        [
                          schoolLanguageOptions[jwt]?.labels[22],
                          calculatedPayment.totalScholarship,
                        ],
                      ].map(([label, value]) => (
                        <div
                          key={label}
                          className="flex items-center justify-between px-4 py-2.5 text-sm"
                        >
                          <dt className="text-slate-500">{label}</dt>
                          <dd className="font-medium text-slate-800">
                            {formatAmount(value)}
                          </dd>
                        </div>
                      ))}
                    </dl>
                    <div className="flex items-center justify-between bg-[#0351b3] px-4 py-4 text-white">
                      <span className="text-sm font-medium">
                        {schoolLanguageOptions[jwt]?.labels[23]}
                      </span>
                      <strong className="text-lg">
                        {formatAmount(calculatedPayment.finalAmount)}
                      </strong>
                    </div>
                  </div>
                </div>
              )}
              <button
                onClick={paymentDetail}
                disabled={paymentActionDisabled}
                className="school-primary-button mt-5"
              >
                {loading ? (
                  <>
                    <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white" />
                    {schoolLanguageOptions[jwt]?.labels[13]}
                  </>
                ) : (
                  <>
                    <span>{buttonText}</span>
                    <ChevronRight size={18} aria-hidden="true" />
                  </>
                )}
              </button>
            </section>
          )}
        </div>
      </div>
      </div>
    </main>
  );
};

export default School;
